import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {  addUserEmail,addUserNikname,addUserPassword } from "../store";

function Register() {
   
    
    let rStore = useSelector((state)=>{return state})
    let dispatch = useDispatch()
    let navigate = useNavigate()
    // console.log(rStore.user)
   
    const [Email, setEmail] = useState('')
    const [Nikname, setNikname] = useState('')
    const [Password, setPassword] = useState('')

    return (
        <div 
        style={{display:'flex', justifyContent:'center',
        height:'100%', alignItems:'center', marginTop:'200px'}}>
             <Form style={{width:'350px'}}>
                <Form.Group className="mb-3" controlId="Email">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="Enter email" 
                        onChange={(e)=>{
                        setEmail(e.target.value)
                        console.log(Email)}}/>
                </Form.Group>
                <Form.Group className="mb-3" controlId="Nikname">
                    <Form.Label>Nikname</Form.Label>
                    <Form.Control placeholder="Enter Nikname" 
                     onChange={(e)=>{
                        setNikname(e.target.value)
                        console.log(Nikname)}}/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="Password">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" placeholder="Password" 
                     onChange={(e)=>{
                        setPassword(e.target.value)
                        console.log(Password)}}/>                    
                </Form.Group>
                <Button variant="primary" style={{float:'Right'}}
                onClick={()=>{ 


                    dispatch(addUserEmail(Email))
                    dispatch(addUserNikname(Nikname))
                    dispatch(addUserPassword(Password))      
                    console.log(rStore.user)       
                    
                    localStorage.setItem('email',Email)
                    localStorage.setItem('nikname',Nikname)
                    localStorage.setItem('password',Password)
                    localStorage.setItem('writed', JSON.stringify([]))
                    navigate('/login')
                    console.log(localStorage.email, localStorage.nikname, localStorage.password)
                }}>
                    가입하기
                </Button>
            </Form>
        </div>
    )

}

export default Register